// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__Aefnf system_captionL__sBgtx"};